import Acceleron from './acceleron';

export default { Acceleron };
